export const errorsMessages = {
    isRequired: `toto pole je vyžadováno`,
    isEmailSpecialChar: 'emailova adresa je ve špatném formátu',

};


